<template>
  <v-container>
    <v-row justify="center" class="app-frame">
      <Date />
      <Recipes />
      <Services />
    </v-row>
  </v-container>
</template>

<script>
import Recipes from "../components/Recipes";
import Services from "../components/Services";
import Date from "../components/Date";
import firebase from "firebase";

export default {
  components: {
    Recipes,
    Services,
    Date,
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.app-frame {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding-left: 100px;
  padding-right: 100px;
  overflow: hidden;
}
</style>
